import { NavItem } from '@billy/design-system'

import { EInvoiceAddressSchemeType } from '../../../../../enums/eInvoiceAddressSchemeType'
import { getEInvoiceCountryConfig } from '../../../../../utils/getEInvoiceCountryConfig'
import { EInvoiceAddressSchemeTypeList } from '../types/eInvoiceAddressSchemeTypeList'

interface GetEInvoiceAddressSchemeTypeOptions {
  countryId?: string
  eInvoiceAddressSchemeTypeList?: EInvoiceAddressSchemeTypeList
}

export const getEInvoiceAddressSchemeType = ({
  eInvoiceAddressSchemeTypeList,
  countryId,
}: GetEInvoiceAddressSchemeTypeOptions): NavItem<EInvoiceAddressSchemeType>[] => {
  const defaultPublicEntityAddressSchemeType = getEInvoiceCountryConfig(countryId)?.defaultPublicScheme

  const eInvoiceAddressSchemeTypes =
    (countryId && eInvoiceAddressSchemeTypeList?.[countryId]) || eInvoiceAddressSchemeTypeList?.INT || []

  const filteredEInvoiceAddressSchemeTypes = eInvoiceAddressSchemeTypes.filter(
    (type) => type !== defaultPublicEntityAddressSchemeType,
  )

  return filteredEInvoiceAddressSchemeTypes.map((type: EInvoiceAddressSchemeType) => ({
    children: type,
    id: type,
    value: type,
  }))
}
